import { Component, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ViewConstants } from 'src/app/constants';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { ValidationTypes } from '../../../shared/model/api/ValidatorTypes';
import { CurrencyPipe } from '@angular/common';
import { isNil } from "lodash";
import { SharedFunctionService } from 'src/app/core/services/shared-func.service';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { HttpClient } from '@angular/common/http';
import { CdkMessageService } from 'src/app/shared/model/common/sdk-message';
import { PaymentSimulatorPdfService } from 'src/app/feature/writeups-detail/services/payment-simulator-pdf.service';
import * as _lodash from 'lodash-es';
import { Library } from 'src/assets/core';
@Component({
  selector: 'app-payment-simulator',
  templateUrl: './payment-simulator.component.html',
  styleUrls: ['./payment-simulator.component.scss']
})
export class PaymentSimulatorComponent implements OnInit {
  @Input() masterData: any;
  @Output() paymentSimulatorPdfEvent: EventEmitter<any> = new EventEmitter();
  disclaimerText = '';
  validationTypes: typeof ValidationTypes = ValidationTypes;
  public vehicleDetailSelections:any[] = [];
  public paymentSimulationForm: FormGroup;
  zipCode: any;
  sellingPrice:any;
  netTrade:any;
  protection:any;
  incentives:any;
  cashDown:any;
  addOns:any;
  apr:any;
  simulatedResponse: Object;
  amountFinanced = null;
  monthlyPayment = null;
  taxesAndFees = null;
  disableCalculate = false;
  paymentServiceError: string;
  checkError: boolean=false;
  selectedSeriesId = null;
  constructor(public sharedDataService: SharedDataService,private _modalService: CdkMessageService,public dataFormatter: SharedFunctionService, private environment: EnvironmentConfiguration, private http: HttpClient,
    private paymentSimulatorPdfService: PaymentSimulatorPdfService) {
    this.zipCode = this.sharedDataService.customerData?.zipCode;
    this.vehicleDetailSelections = [
      {label: ViewConstants.VehicleYEAR, isDisabled: false, isEditable: false, fieldName:'years' ,icon: 'tmi tmi-arrow-half-dwn', options: []},
      {label: ViewConstants.VehicleMAKE, isDisabled: true, isEditable: false, fieldName:'make' ,icon: 'tmi tmi-arrow-half-dwn', options: []},
      {label: ViewConstants.VehicleSERIES, isDisabled: true, isEditable: false, fieldName:'series' ,icon: 'tmi tmi-arrow-half-dwn', options: []},
      {label: ViewConstants.VehicleMODELTRIM, isDisabled: true, isEditable: false, fieldName:'model' ,icon: 'tmi tmi-arrow-half-dwn', options: []},
      {label: ViewConstants.VehicleSALESCLASS, isDisabled: true, isEditable: false, fieldName:'salesClass' ,icon: 'tmi tmi-arrow-half-dwn', options: []},
      {label: ViewConstants.VehicleTYPE, isDisabled: true, isEditable: false, fieldName:'vehicleType' ,icon: 'tmi tmi-arrow-half-dwn', options: ['Corolla', 'Camry', 'Prius', 'Highlander', 'Rav4', '4Runner', 'Land Cruiser']},
      {label: ViewConstants.VehicleFUELTYPE, isDisabled: true, isEditable: false, fieldName:'fuelType' ,icon: 'tmi tmi-arrow-half-dwn', options: ['Gasoline', 'Electricity', 'Hydrogen Fuel']},
      {label: ViewConstants.VehicleHORSEPOWER, isDisabled: true, isEditable: false, fieldType: 'number', fieldName:'horsePower'}
    ];
    this.paymentSimulationForm = new FormGroup({
      vehicle: new FormGroup({
        years: new FormControl('Select', [Validators.required, Validators.pattern(/[^Select]/)]),
        make: new FormControl('Select', [Validators.required, Validators.pattern(/[^Select]/)]),
        series: new FormControl('Select', [Validators.required, Validators.pattern(/[^Select]/)]),
        model: new FormControl('Select', [Validators.required, Validators.pattern(/[^Select]/)]),
        salesClass: new FormControl('Select', [Validators.required, Validators.pattern(/[^Select]/)]),
        vehicleType: new FormControl('Select', [Validators.required, Validators.pattern(/[^Select]/)]),
        fuelType: new FormControl('Select', [Validators.required, Validators.pattern(/[^Select]/)]),
        horsePower: new FormControl('', [Validators.required, Validators.pattern(/\d/)]),
      }),
      payment: new FormGroup({
        paymentType: new FormControl('Select', [Validators.required, Validators.pattern(/[^Select]/)]),
        term: new FormControl('', [Validators.required]),
        zipCode: new FormControl(this.zipCode ? this.zipCode : '', [Validators.required]),
      }),
      pricing: new FormGroup({
        sellingPrice: new FormControl('', [Validators.required]),
        apr: new FormControl('', [Validators.required]),
        netTrade: new FormControl('$0', [Validators.required]),
        cashDown: new FormControl('', [Validators.required]),
        addOns: new FormControl('$0', [Validators.required]),
        protection: new FormControl('$0', [Validators.required]),
        incentives: new FormControl('$0', [Validators.required]),
      }),
    })
  }
  enableOrDisableTabIndex(val){
    if(val){
      return -1;
    }else{
      return 0;
    }
  }
  ngOnInit(): void {
    if(!isNil(this.masterData)){
      this.disclaimerText = this.masterData['disclaimer'];
      const masterDataProps = ['years', 'fuelType', 'make', 'salesClass', 'vehicleType'];
      masterDataProps.forEach(prop =>{
        const fieldIndex = this.vehicleDetailSelections.findIndex(vds => vds.fieldName == prop);
        if(fieldIndex != -1) this.vehicleDetailSelections[fieldIndex].options = this.masterData[prop];
      });
    }
    this.paymentSimulationForm.get(['payment','paymentType']).valueChanges.subscribe(val=>{
      if(val == "cash"){
        this.paymentSimulationForm.controls['payment']['controls']['term'].clearValidators();
        this.paymentSimulationForm.controls['payment']['controls']['term'].reset();
        this.paymentSimulationForm.controls['pricing']['controls']['apr'].clearValidators();
        this.paymentSimulationForm.controls['pricing']['controls']['apr'].reset();
        this.paymentSimulationForm.controls['pricing']['controls']['cashDown'].clearValidators();
        this.paymentSimulationForm.controls['pricing']['controls']['cashDown'].reset();
      }else{
        this.paymentSimulationForm.controls['payment']['controls']['term'].setValidators([Validators.required]);
        this.paymentSimulationForm.controls['pricing']['controls']['apr'].setValidators([Validators.required]);
        this.paymentSimulationForm.controls['pricing']['controls']['cashDown'].setValidators([Validators.required]);
      }
      this.paymentSimulationForm.controls['payment']['controls']['term'].updateValueAndValidity();
      this.paymentSimulationForm.controls['pricing']['controls']['apr'].updateValueAndValidity();
      this.paymentSimulationForm.controls['pricing']['controls']['cashDown'].updateValueAndValidity();
    })
    this.paymentSimulationForm.valueChanges.subscribe(data=>{
      if(this.paymentSimulationForm.value.payment.paymentType.toLowerCase() == "cash"){
        if(this.amountFinanced != null && this.taxesAndFees !=null && this.disableCalculate){
          this.disableCalculate = false;
        }
      }
      if(this.paymentSimulationForm.value.payment.paymentType.toLowerCase() == "finance"){
        if(this.amountFinanced != null && this.taxesAndFees !=null && this.monthlyPayment != null && this.disableCalculate){
          this.disableCalculate = false;
        }
      }
    })
  }
  onValueChange(event){
    const eventTarget = event.target;
    if(eventTarget.id == 'series'){
      const modelFieldIndex = this.vehicleDetailSelections.findIndex(vds => vds.fieldName == 'model');
      if(modelFieldIndex != -1 && eventTarget.value != '') this.vehicleDetailSelections[modelFieldIndex].isDisabled = false;
      else this.vehicleDetailSelections[modelFieldIndex].isDisabled = true;
    }else if(eventTarget.id == 'model'){
      const modelFieldIndex = this.vehicleDetailSelections.findIndex(vds => vds.fieldName == 'vehicleType');
      if(modelFieldIndex != -1 && eventTarget.value != '') this.vehicleDetailSelections[modelFieldIndex].isDisabled = false;
      else this.vehicleDetailSelections[modelFieldIndex].isDisabled = true;
    }
  }

  get isCashSelected(){
    return this.paymentSimulationForm.value.payment.paymentType.toLowerCase() == "cash";
  }
 get enablePrint(){
  if(this.paymentSimulationForm.value.payment.paymentType.toLowerCase() == "cash"){
    if(this.amountFinanced != null && this.taxesAndFees !=null && this.disableCalculate){
      return true;
    }
  }else if(this.paymentSimulationForm.value.payment.paymentType.toLowerCase() == "finance"){
    if(this.amountFinanced != null && this.taxesAndFees !=null && this.monthlyPayment != null && this.disableCalculate){
      return true;
    }
  }
  return false;
}

  onChange(paymentType){
    if(paymentType == "cash"){
      this.amountFinanced = null;
      this.taxesAndFees = null;
      this.disableCalculate = false;
      document.getElementById('apr-id').tabIndex = -1;
      document.getElementById('cashdown').tabIndex = -1;
      document.getElementById('term-id').tabIndex = -1;
    }
    if(paymentType == "finance"){
      this.monthlyPayment = null;
      this.amountFinanced = null;
      this.taxesAndFees = null;
      this.disableCalculate = false;
      document.getElementById('apr-id').tabIndex = 0;
      document.getElementById('cashdown').tabIndex = 0;
      document.getElementById('term-id').tabIndex = 0;
    }
  }
  
  convertToNormalPrice(field, value){
    if(value != '' && field == 'netTrade'){
      this.netTrade = this.dataFormatter.convertToNormalPrice(value).toString();
    }else
    if(value != '' && field == 'addOns'){
      this.addOns = this.dataFormatter.convertToNormalPrice(value).toString();
    }else
    if(value != '' && field == 'protection'){
      this.protection = this.dataFormatter.convertToNormalPrice(value).toString();
    }else
    if(value != '' && field == 'incentives'){
      this.incentives = this.dataFormatter.convertToNormalPrice(value).toString();
    }else
    if(value != '' && field == 'cashDown'){
      this.cashDown = this.dataFormatter.convertToNormalPrice(value).toString();
    }else
    if(value != '' && field == 'sellingPrice'){
      this.sellingPrice = this.dataFormatter.convertToNormalPrice(value).toString();
    }

    let element = <HTMLInputElement>document.getElementById(field);
      setTimeout(()=> {
          element?.select();
      })
    
  }

  convertToCurrencyPrice(field, value){
    if(value !== '' && !Library.isNullOrUndefined(value)){
    value = value.replace('$', '');
    if (value != '' && field == 'netTrade') {
      this.netTrade = new CurrencyPipe(ViewConstants.EN_US)
        .transform(value, ViewConstants.USD, true, '1.0').toString()
    }else
    if (value != '' && field == 'addOns') {
      this.addOns = new CurrencyPipe(ViewConstants.EN_US)
        .transform(value, ViewConstants.USD, true, '1.0').toString()
    }else
    if (value != '' && field == 'protection') {
      this.protection = new CurrencyPipe(ViewConstants.EN_US)
        .transform(value, ViewConstants.USD, true, '1.0').toString()
    }else
    if (value != '' && field == 'incentives') {
      this.incentives = new CurrencyPipe(ViewConstants.EN_US)
        .transform(value, ViewConstants.USD, true, '1.0').toString()
    }else
    if (value != '' && field == 'cashDown') {
      this.cashDown = new CurrencyPipe(ViewConstants.EN_US)
        .transform(value, ViewConstants.USD, true, '1.0').toString()
    }else
    if (value != '' && field == 'sellingPrice') {
      this.sellingPrice = new CurrencyPipe(ViewConstants.EN_US)
        .transform(value, ViewConstants.USD, true, '1.0').toString()
    }
  }
  }

  convertAprToNormalValue(value) {
    if(value != ''){
      let modifiedValue = parseFloat(value
        .replace(ViewConstants.PERCENTAGE_SYMBOL, ViewConstants.EMPTY_STRING)
        .replace(/,/g, ViewConstants.EMPTY_STRING))
        this.apr = modifiedValue;
        let element = <HTMLInputElement>document.getElementById('apr-id');
        setTimeout(()=> {
            element?.select();
        })
    }
  }

  convertAprtToPercentage(value){
    if(value != '' && !Library.isNullOrUndefined(value)){
      value = value.replace('%', '');
      this.apr = Number(value).toFixed(2).toString()+"%";
    }
  }

  get isFormValid(){
    return this.paymentSimulationForm.valid;
  }
  setHorsePowerToMinOrMax(event){
    const horsePower = event.target.value;
    const potentialVehicleForm = this.paymentSimulationForm.get('vehicle')
    if(!isNil(horsePower)){
      if(horsePower < 50) potentialVehicleForm.get('horsePower').setValue(50);
      else if(horsePower > 1000) potentialVehicleForm.get('horsePower').setValue(1000);
    }
  }
  public dropdownPopup(index, icon) {
    const HALF_DOWN_ICON = 'tmi tmi-arrow-half-dwn';
    const HALF_UP_ICON = 'tmi tmi-arrow-half-up';
    this.vehicleDetailSelections = [...this.vehicleDetailSelections.map((option, i, arr) => {
      if(i < arr.length - 1){
        if(index == i && icon == HALF_DOWN_ICON){
          option.icon = HALF_UP_ICON;
        }else if(option.icon != null){
          option.icon = HALF_DOWN_ICON;
        }
      }
      return option;
    })]
  }
  @HostListener('document:click', ['$event'])  
  closeDropdowns(event){
    if(event.target.id != 'dropdown-btn' && event.target?.nextElementSibling?.id != 'dropdown-btn'){
      this.dropdownPopup(100, '');
    }
    if(event.key=="Escape"){
      this.closePaymentSimulatorModal() 
    }
   
  }
  onOptionSelected(index,fieldName, option, event, icon){
    event.stopPropagation();
    this.paymentSimulationForm.get('vehicle').get(fieldName).setValue(option.name);
    this.vehicleDetailSelections = this.vehicleDetailSelections.map(vds =>{
      if(vds.icon === null && index < 5) vds.icon = 'tmi tmi-arrow-half-dwn';
      if(vds.fieldName == 'horsePower') vds.isEditable = true;
      else vds.isEditable = false;
      vds.isDisabled = true;
      return vds;
    })
    this.resetAndDisableFields(fieldName);
    if(fieldName == 'make'){
      this.getSeriesOrTrims("", option).subscribe(response => {
        const currentYear = new Date().getFullYear();
        const selectedYear = this.paymentSimulationForm.get('vehicle').get('years').value
        const fieldIndex = this.vehicleDetailSelections.findIndex(vds => vds.fieldName == 'series');
        if(fieldIndex != -1) this.vehicleDetailSelections[fieldIndex].options = [..._lodash.sortBy(response['choices'], [row=>row['name'].toLowerCase()])];
        if(selectedYear >= currentYear) this.vehicleDetailSelections[fieldIndex].options.push({name: 'Other'});
      })
    }else if(fieldName == 'series'){
      if(option.name == 'Other'){
        this.paymentSimulationForm.get('vehicle').get('salesClass').setValue('New');
        document.querySelector<HTMLInputElement>('[id="series"]')?.focus();//focus the Series field.
        this.paymentSimulationForm.get('vehicle').get('series').setValue('');
        this.paymentSimulationForm.get('vehicle').get('model').setValue('');
        this.vehicleDetailSelections = this.vehicleDetailSelections.map(vds =>{
          const editableFields = 'series model';
          if(editableFields.includes(vds.fieldName)) vds.isEditable = true;
          if(vds.fieldName.includes('model')){
            vds.isDisabled = true;
            vds.icon = null;
          }
          return vds;
        })
      }else{
        this.getSeriesOrTrims(fieldName, option).subscribe(response =>{
          const fieldIndex = this.vehicleDetailSelections.findIndex(vds => vds.fieldName == 'model');
          if(fieldIndex != -1) this.vehicleDetailSelections[fieldIndex].options = _lodash.sortBy(response['choices'], [row=>row['name'].toLowerCase()]);
        })
      }
    }else if(fieldName == 'model'){
       this.getSeriesOrTrims(fieldName, option).subscribe(response =>{
        this.paymentSimulationForm.get('vehicle').get('salesClass').setValue('New');
        let matchedVehicleType = false;
        let matchedFuelType = false;
        this.sharedDataService.getVehicleAttributesMasterData.vehicleType.forEach((type,i) => {
          if(type?.id?.toLowerCase() === response['vehicle']?.type?.toLowerCase()) {
            this.paymentSimulationForm.get('vehicle').get('vehicleType').setValue(type.name);
            this.sharedDataService.getVehicleAttributesMasterData.vehicleType[i]['weightRating']=response['vehicle']?.weightRating;
            this.sharedDataService.getVehicleAttributesMasterData['baseMsrp']=response['vehicle']?.price?.baseMsrp;
            this.sharedDataService.getVehicleAttributesMasterData['totalMsrp']=response['vehicle']?.price?.totalMsrp;
            matchedVehicleType = true;
          }
        })
        if(!matchedVehicleType) {
          this.paymentSimulationForm.get('vehicle').get('vehicleType').setValue(response['vehicle'].type);
        }
        this.sharedDataService.getVehicleAttributesMasterData.fuelType.forEach((type) => {
          if(type?.id?.toLowerCase() === response['vehicle']['engine']?.fuelType?.toLowerCase()) {
            this.paymentSimulationForm.get('vehicle').get('fuelType').setValue(type.name);
            matchedFuelType = true;
          }
        })
        if(!matchedFuelType) {
          this.paymentSimulationForm.get('vehicle').get('fuelType').setValue(response['vehicle']['engine'].fuelType);
        }
        this.paymentSimulationForm.get('vehicle').get('horsePower').setValue(response['vehicle']['engine'].horsepower);
      });
      this.vehicleDetailSelections = [...this.vehicleDetailSelections.map((option) => {
        const disabledFields = 'vehicleType fuelType horsePower';
        if(disabledFields.includes(option.fieldName)) option.isDisabled = true;
        return option;
      })]
    }else if(fieldName == 'salesClass'){
      this.vehicleDetailSelections = [...this.vehicleDetailSelections.map((option) => {
        const disabledFields = 'vehicleType fuelType horsePower';
        if(disabledFields.includes(option.fieldName)) option.isDisabled = true;
        return option;
      })]
    }else if(fieldName == 'vehicleType'){
      const fieldIndex = this.vehicleDetailSelections.findIndex(vds => vds.fieldName == 'fuelType');
      if(fieldIndex != -1) this.vehicleDetailSelections[fieldIndex].isDisabled = false;
      this.vehicleDetailSelections = [...this.vehicleDetailSelections.map((option) => {
        const disabledFields = 'salesClass';
        if(disabledFields.includes(option.fieldName)) option.isDisabled = true;
        return option;
      })]
    }else if(fieldName == 'fuelType'){
      const fieldIndex = this.vehicleDetailSelections.findIndex(vds => vds.fieldName == 'horsePower');
      if(fieldIndex != -1) this.vehicleDetailSelections[fieldIndex].isDisabled = false;
      this.vehicleDetailSelections = [...this.vehicleDetailSelections.map((option) => {
        const disabledFields = 'salesClass';
        if(disabledFields.includes(option.fieldName)) option.isDisabled = true;
        return option;
      })]
    }
    
    this.dropdownPopup(index, icon);
  }
  private resetAndDisableFields(fieldName){
    const vehicleForm = this.paymentSimulationForm.get('vehicle') as FormGroup;
    const selectedFieldIndex = this.vehicleDetailSelections.findIndex(field => field.fieldName == fieldName);
    const formFieldNames = Object.keys(vehicleForm.controls).slice(selectedFieldIndex+1);
    formFieldNames.forEach(_fieldName => { //loop through Potential Vehicle FormGroup & reset dropdowns to "Select"
      if(fieldName != 'salesClass'){
        if(_fieldName == 'horsePower') this.paymentSimulationForm.get('vehicle').get(_fieldName).setValue('');
        else this.paymentSimulationForm.get('vehicle').get(_fieldName).setValue('Select');
      }
    });
    this.vehicleDetailSelections = this.vehicleDetailSelections.map((vds, index) =>{
      if(index <= selectedFieldIndex+1) vds.isDisabled = false;
      return vds;
    })
  }
  private getSeriesOrTrims(fieldName, option){
    const vehicleFormGroup = this.paymentSimulationForm.get('vehicle');
    const path = this.environment.MST_BASE_SERVICE_URL + `payment-nexgen/dealers/${this.sharedDataService.dealerCode}/simulator/getVehicleAttributes`;
    const selectedYear = vehicleFormGroup.get('years').value;
    const selectedMake = vehicleFormGroup.get('make').value;
    const selectedSerie = vehicleFormGroup.get('series').value;
    const selectedTrim = vehicleFormGroup.get('model').value;
    const payload = {
      provider: ViewConstants.TOYOTA,
      senderId: "MST",
      year: {name: selectedYear, id: selectedYear},
      make: {name: selectedMake, id: selectedMake}
    }
    if(fieldName == 'series'){
      this.selectedSeriesId = option.id;
      payload['model'] = {name: selectedSerie, id: option.id}
    }
    if(fieldName == 'model'){
      payload['model'] = {name: selectedSerie, id: this.selectedSeriesId}
      payload['trim'] = {name: selectedTrim, id: option.id};
    }
    return this.http.post(path, payload);
  }
  closePaymentSimulatorModal(){
    this.dataFormatter.enableOrDisableTabing('0');
    this.sharedDataService.showPaymentSimulatorModal = false;
  }
  Oncalculate(){
    const vehicleType=this.paymentSimulationForm.value.vehicle.vehicleType;
    const vehicleTypeId=this.masterData['vehicleType'].find(dt=> dt?.name && vehicleType && (dt?.name.toLowerCase()===vehicleType.toLowerCase()))?.id
    const fuelType=this.paymentSimulationForm.value.vehicle.fuelType;
    const fuelTypeId=this.masterData['fuelType'].find(dt=>dt?.name && fuelType && (dt?.name.toLowerCase()===fuelType.toLowerCase()))?.id;
    const weight=this.masterData['vehicleType'].find(dt=>dt?.name && vehicleType && (dt.name.toLowerCase()===vehicleType.toLowerCase()))?.weightRating;
    let paymentCallPayoad={};
    paymentCallPayoad['vehicle']= {
      "year": this.paymentSimulationForm.value.vehicle.years,
      "make": this.paymentSimulationForm.value.vehicle.make,
      "saleClass": this.paymentSimulationForm.value.vehicle.salesClass.toLowerCase(),
      "series": this.paymentSimulationForm.value.vehicle.series,
      "marketingSeries": this.paymentSimulationForm.value.vehicle.series,
      "marketingStyle": this.paymentSimulationForm.value.vehicle.model,
      "engine": {
        "fuelType": fuelTypeId,
        "horsepower": Number(this.paymentSimulationForm.value.vehicle.horsePower)
      },
      "price": {
        "baseMsrp": Library.isNullOrUndefined(this.sharedDataService.getVehicleAttributesMasterData?.['baseMsrp']) ? Number(this.dataFormatter.convertToNormalPrice(this.paymentSimulationForm.value.pricing.sellingPrice)) : Number(this.sharedDataService.getVehicleAttributesMasterData?.['baseMsrp']),
        "totalMsrp": Library.isNullOrUndefined(this.sharedDataService.getVehicleAttributesMasterData?.['totalMsrp'])? Number(this.dataFormatter.convertToNormalPrice(this.paymentSimulationForm.value.pricing.sellingPrice)): Number(this.sharedDataService.getVehicleAttributesMasterData?.['totalMsrp']),
        "sellingPrice": Number(this.dataFormatter.convertToNormalPrice(this.paymentSimulationForm.value.pricing.sellingPrice)),
      },
      "type":vehicleTypeId,
      "weightRating": weight,
      "grossWeightRating": weight
    },
    paymentCallPayoad['paymentType']= this.paymentSimulationForm.value.payment.paymentType=='finance'? 'apr':'cash',
    paymentCallPayoad['zipCode']=this.paymentSimulationForm.value.payment.zipCode,
    paymentCallPayoad['netTrade']= Number(this.dataFormatter.convertToNormalPrice(this.paymentSimulationForm.value.pricing.netTrade)),
    paymentCallPayoad['totalDioAmount']= Number(this.dataFormatter.convertToNormalPrice(this.paymentSimulationForm.value.pricing.addOns)),
    paymentCallPayoad['totalIncentives']= Number(this.dataFormatter.convertToNormalPrice(this.paymentSimulationForm.value.pricing.incentives)),
    paymentCallPayoad["rate"]= parseFloat(parseFloat(this.paymentSimulationForm.value.pricing.apr).toFixed(2)),
    paymentCallPayoad["term"]= Number(this.paymentSimulationForm.value.payment.term),
    paymentCallPayoad["cashDown"]= Number(this.dataFormatter.convertToNormalPrice(this.paymentSimulationForm.value.pricing.cashDown)),
    paymentCallPayoad["totalPpAmount"]= Number(this.dataFormatter.convertToNormalPrice(this.paymentSimulationForm.value.pricing.protection)),
    paymentCallPayoad["dealer"]= {
      "code": this.sharedDataService.dealerCode,
      "address": {
        "city": this.sharedDataService.dealerPostalAddress.cityName.value,
        "zipCode": this.sharedDataService.dealerZipCode,
        "stateCode": this.sharedDataService.dealerStateOrProvinceId
      },
      "division": "TMNA",
      "regionName": this.sharedDataService.dealerName
    },
    paymentCallPayoad["senderId"]= "MST"

  const path=this.environment.MST_BASE_SERVICE_URL +`payment-nexgen/dealers/${this.sharedDataService.dealerCode}/simulator/payments`
  this.http.post(path, paymentCallPayoad).subscribe(data=>{
    this.simulatedResponse=data;
    if(!isNil(data['response'])){
      if(data && (!isNil(data['response']['retail'])) && (!isNil(data['response']['retail'])) && (isNil(data['response']['retail']['errorCode']))) {
        if(!isNil(this.simulatedResponse) && !isNil(this.simulatedResponse['response']) && !isNil(this.simulatedResponse['response']['retail']) && !isNil(this.simulatedResponse['response']['retail'][0]) && !isNil(this.simulatedResponse['response']['retail'][0][0]))
        {
      this.monthlyPayment=this.simulatedResponse['response']['retail'][0][0].paymentWithTaxes.monthlyPayment;
      this.amountFinanced=this.simulatedResponse['response']['retail'][0][0].paymentWithTaxes.amountFinanced;
      this.taxesAndFees=Number(this.simulatedResponse['response']['retail'][0][0].paymentWithTaxes.totalTaxes) + Number(this.simulatedResponse['response']['retail'][0][0].paymentWithTaxes.totalFees);
      this.disableCalculate = true;
    }
  }

  if(data && (!isNil(data['response']['cash'])) &&  (isNil(data['response']['cash']['errorCode']))) {
    if(!isNil(this.simulatedResponse) && !isNil(this.simulatedResponse['response']) && !isNil(this.simulatedResponse['response']['cash']) && !isNil(this.simulatedResponse['response']['cash'][0]) && !isNil(this.simulatedResponse['response']['cash'][0][0]))
    {
      this.amountFinanced=this.simulatedResponse['response']['cash'][0][0].paymentWithTaxes.outTheDoorPrice;
      this.taxesAndFees=Number(this.simulatedResponse['response']['cash'][0][0].paymentWithTaxes.totalTaxes) + Number(this.simulatedResponse['response']['cash'][0][0].paymentWithTaxes.totalFees);
      this.disableCalculate = true;
    }
  }

  if(data && (!isNil(data['response']['cash'])) &&  (!isNil(data['response']['cash']['errorCode']))){
    this.displayPaymentServiceError();
  }
  if(data && (!isNil(data['response']['retail'])) &&  (!isNil(data['response']['retail']['errorCode']))){
    this.displayPaymentServiceError();
  }
  if(!isNil(this.simulatedResponse) && !isNil(this.simulatedResponse['response']) && !isNil(this.simulatedResponse['response']['cash']) && !isNil(this.simulatedResponse['response']['cash'][0]) && !isNil(this.simulatedResponse['response']['cash'][0][0]) && !isNil(this.simulatedResponse['response']['cash'][0][0].paymentWithTaxes['errorCode'])){
    this.displayPaymentServiceError();
  }
  if(!isNil(this.simulatedResponse) && !isNil(this.simulatedResponse['response']) && !isNil(this.simulatedResponse['response']['retail']) && !isNil(this.simulatedResponse['response']['retail'][0]) && !isNil(this.simulatedResponse['response']['retail'][0][0]) && !isNil(this.simulatedResponse['response']['retail'][0][0].paymentWithTaxes['errorCode'])){
    this.displayPaymentServiceError();
  }
}else{
  this.displayPaymentServiceError()
}
})
}
  displayPaymentServiceError() {
    this.paymentServiceError = "The service is temporarily unavailable. Please try again later";
    this.checkError=true;
    if(!isNil(this.simulatedResponse) && !isNil(this.simulatedResponse['response'])){
      const response = this.simulatedResponse['response'];
      if(!isNil(response['retail']) && !isNil(response['retail'][0]) && !isNil(response['retail'][0][0]) && !isNil(response['retail'][0][0].paymentWithTaxes['errorCode']))
      {
        this.paymentServiceError=response['retail'][0][0].paymentWithTaxes['errorMessage'];
      }
      else if(!isNil(response['cash']) && !isNil(response['cash'][0]) && !isNil(response['cash'][0][0]) && !isNil(response['cash'][0][0].paymentWithTaxes['errorCode']))
      {
        this.paymentServiceError=response['cash'][0][0].paymentWithTaxes['errorMessage'];
      }
    }else if(!isNil(this.simulatedResponse) && !isNil(this.simulatedResponse['retail'])){
      this.paymentServiceError = this.simulatedResponse['retail']['message'];
    }
  }
  closeErrorMessage(){
    this._modalService.dispatch({ action: 'close' });
    this.checkError=false;
  }

  public printPDFData: any;
  public filenameForDownload: string;

  print() {
    this.printPDFData = null;
    const pdfData = {
      vehicle: {
        "year": this.paymentSimulationForm.value.vehicle.years,
        "make": this.paymentSimulationForm.value.vehicle.make,
        "saleClass": this.paymentSimulationForm.value.vehicle.salesClass,
        "series": this.paymentSimulationForm.value.vehicle.series,
        "marketingStyle": this.paymentSimulationForm.value.vehicle.model,
        "price": {
          "baseMsrp": Number(this.paymentSimulationForm.value.pricing.sellingPrice),
          "totalMsrp": Number(this.paymentSimulationForm.value.pricing.sellingPrice),
          "sellingPrice": Number(this.paymentSimulationForm.value.pricing.sellingPrice),
        },
        "cashDown": this.paymentSimulationForm.value.pricing.cashDown,
        "term": this.paymentSimulationForm.value.payment.term,
        "apr": this.paymentSimulationForm.value.pricing.apr,
        "sellingPrice": this.paymentSimulationForm.value.pricing.sellingPrice,
        "netTrade": this.paymentSimulationForm.value.pricing.netTrade,
        "incentives": this.paymentSimulationForm.value.pricing.incentives,
        "protection": this.paymentSimulationForm.value.pricing.protection,
        "addOns": this.paymentSimulationForm.value.pricing.addOns,
        "amountFinanced": this.amountFinanced,
        "taxesAndFees": this.taxesAndFees
      },
      customer: this.sharedDataService.customerData, 
      disclaimerText: this.disclaimerText,
      paymentType: this.paymentSimulationForm.value.payment.paymentType
      
    }
    if(this.simulatedResponse['response']['retail']){
      pdfData.vehicle["monthly"] = this.simulatedResponse['response']['retail'][0][0].paymentWithTaxes.monthlyPayment;
    }
    const pdfDocGenerator = this.paymentSimulatorPdfService.generatePdf([pdfData]);
    pdfDocGenerator.getBase64(data => {
      this.paymentSimulatorPdfEvent.emit({filenameForDownload: 'Payment Simulator', printPDFData: data});
    });
  }

  preventDrag(event: DragEvent) {
    event.preventDefault();
  }
  
  preventDrop(event: DragEvent) {
    event.preventDefault();
  }
  
}